<template>
  <v-container class="overview-page">

    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>line_weight</v-icon>
          {{ $t('common:process_plural') }}
        </h2>

        <DataTable
            :enabledSearch="true"
            :addBtn="true"
            :addBtnRoute="`/${$store.state.manager.bookModuleUrl}/admin/process/base/edit`"
            :addBtnText="$t('buttons:add-specific', { specific: $t('common:process')})"
            :headers="headers"
            :data="table.data"
            icon="create"
            @clickedButton1="editProcessBase"
            checkbox-on-property="documentationRequired"
            sortBy="name"
            @cacheCommit="$store.commit('book/admin/storeProcessBaseOverviewSearch', $event)"
            :cachedSearch="$store.state.book.admin.processBaseOverviewSearch"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProcessService from "@/modules/book/services/process/impl/process-service"
import DataTable from "@/modules/core/components/DataTable/DataTable";
import DataUtils from "@/modules/core/services/data-utils";
import Process from "@/modules/book/data/process";
import Utils from "@/modules/core/services/utils";

export default {
  name: "ProcessBaseOverview",
  components: {
    DataTable
  },
  data() {
    return {
      table: {
        data: []
      }
    }
  },
  methods: {
    editProcessBase(item) {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/admin/process/base/edit/${item.id}`);
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t("common:process"), value: 'name'},
        {text: this.$t("common:description"), value: 'description'},
        {
          text: this.$t("common:process-step_plural"),
          value: 'processSteps.length',
          sortable: false
        },
        {text: this.$t("common:settings"), value: 'controls', sortable: false},
      ]
    }
  },
  created() {
    ProcessService.readAllFromAPI(
      (res) => {
        this.table.data = DataUtils.parseDataToObjectArray(res.data, Process);
      },
      (error) => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:process_plural')}))
        this.$logger.error(error);
      }
    )
  }
}
</script>
